import { render } from "./add_configure.vue?vue&type=template&id=33c89b57"
import script from "./add_configure.vue?vue&type=script&lang=js"
export * from "./add_configure.vue?vue&type=script&lang=js"

import "./add_configure.vue?vue&type=style&index=0&id=33c89b57&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__